/** Default personal-task category stored in DB (Thai canonical value). */
export const DEFAULT_CATEGORY = 'ทั่วไป';

export function displayCategory(name: string | null | undefined, t: (key: string) => string): string {
  const n = (name || DEFAULT_CATEGORY).trim();
  if (n === DEFAULT_CATEGORY || n === 'general') return t('category.general');
  return n;
}
